const init = {}

const customerReducer = (state = init, action) => {

    switch (action.type) {
        default: return state
    }
}

export default customerReducer